import FileUploadField from './file';
import { TableEditorFieldReader } from './tableEditor/tableEditor.field.reader';
import TitleField from './title';

export const fieldsReader = {
  FileUploadField,
  TitleField,
  DataEditorWidget: TableEditorFieldReader
} as Record<string, any>;
